module.exports = __webpack_public_path__ + "static/leftAlignedWhyReload-a5ae41e851198a64b387a6457921860d.png";